/**
 * shared/chores-seeds.ts — the common-chore library behind the Chores
 * creation picker (card VmoORelj1HuO).
 *
 * Forty titles a household recognises, grouped so the panel can show them as
 * one scrollable list instead of a wall. It stays a static array, not a model
 * call: the point of a seed is that it is instant, offline and free, and the
 * tap that picks two of them must never wait on a round trip.
 *
 * The five pills card eudAJs92EZ9B shipped keep their exact wording — they
 * now live inside the group each one belongs to.
 */

export interface ChoreSeedGroup {
  group: string;
  titles: string[];
}

export const CHORE_SEED_GROUPS: ChoreSeedGroup[] = [
  {
    group: 'Kitchen',
    titles: ['Laundry', 'Meal prep', 'Wash up', 'Wipe the benches', 'Clean the fridge', 'Clean the oven', 'Mop the floor'],
  },
  {
    group: 'Laundry & beds',
    titles: ['Sheets', 'Towels', 'Ironing', 'Fold and put away', 'Change the bed'],
  },
  {
    group: 'Home',
    titles: ['Bins', 'Vacuum', 'Dust', 'Clean the bathroom', 'Windows', 'Clean the mirrors'],
  },
  {
    group: 'Outside',
    titles: ['Water the plants', 'Mow the lawn', 'Weeding', 'Sweep the path', 'Wash the car', 'Bring the bins in', 'Wipe the bins'],
  },
  {
    group: 'Errands',
    titles: ['Groceries', 'Pharmacy run', 'Post office', 'School run', 'Top up the coffee'],
  },
  {
    group: 'Pets',
    titles: ['Feed the cat', 'Walk the dog', 'Clean the litter tray', 'Wash the pet bowls', 'Refill the water bowls'],
  },
  {
    group: 'Admin',
    titles: ['Pay a bill', 'Plan the week', 'Tidy the entry', 'Restock the fridge', 'Sort the paperwork'],
  },
];

/** Flat list for probes and callers that want one array; the group order is
 *  Kitchen → Laundry & beds → Home → Outside → Errands → Pets → Admin. The
 *  five pills card eudAJs92EZ9B shipped are all still in here — they simply
 *  sit inside their own groups now instead of in a row of five. */
export const CHORE_SEEDS: string[] = CHORE_SEED_GROUPS.flatMap(g => g.titles);
